import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/console/members";

export const purchases = {
    // ...example,
    gets(_member, data){
        return axios.get(`${url}/${_member}/purchases`, data).then(result => result.data);
    },
}
